'use client'

import { ProductCard } from '@web/components/product-card/product-card'
import type { ProductType } from 'cf-menu/components/search/search.types'
interface CardComponentProps {
  href: string
  productId: number
  productTitle: string
  productThumbnailUrl: string
  categoryText: string
  productType: ProductType
  subcategory?: string
  imageClassName?: string
}

export const CardComponent = ({
  href,
  productId,
  productTitle,
  productThumbnailUrl,
  categoryText,
  productType,
  subcategory,
  imageClassName,
}: CardComponentProps) => {
  // Sanitize product title HTML for use inside anchor
  const sanitizedTitle = sanitizeHtmlForAnchor(productTitle)

  return (
    <ProductCard
      productId={productId.toString()}
      productUrl={href}
      image={productThumbnailUrl}
      name={sanitizedTitle}
      imageWidth={300}
      imageHeight={300}
      category={productType}
      categoryText={categoryText}
      subcategory={subcategory}
      imageClassName={imageClassName}
      isLegacy
    />
  )
}

// Sanitize HTML for use inside anchor tags
function sanitizeHtmlForAnchor(html: string): string {
  // List of tags that can't be nested in an anchor
  const invalidTags = ['a', 'button', 'input', 'select', 'textarea', 'iframe', 'embed']

  let sanitized = html

  // Remove each invalid tag type using regex
  invalidTags.forEach(tag => {
    // This regex pattern matches both self-closing and regular tags
    const tagPattern = new RegExp(`<${tag}[^>]*>(.*?)<\\/${tag}>|<${tag}[^>]*\\/>`, 'gi')
    // Replace the tag with its content (if any)
    sanitized = sanitized.replace(tagPattern, '$1')
  })

  return sanitized
}
